import { useEffect, useMemo } from 'react';
import PubSub from 'pubsub-js';
export var usePubSub = function usePubSub(topic, cb) {
  var token = useMemo(function () {
    return PubSub.subscribe(topic, function (_, data) {
      cb(data);
    });
  }, [topic, cb]);
  useEffect(function () {
    return function () {
      PubSub.unsubscribe(token);
    };
  }, [token]);
};